import { render, staticRenderFns } from "./ProductReturnForm.vue?vue&type=template&id=8d90ab6e&"
import script from "./ProductReturnForm.vue?vue&type=script&lang=js&"
export * from "./ProductReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports